<p-dialog *ngIf="displayTaskBalanceDialog" [(visible)]="displayTaskBalanceDialog"
          header="Project Task Balance" [style]="PrimeNgConfig.DialogStyle65" (onHide)="hideDialog()"
          [contentStyle]="{'overflow-y':'auto'}" [closable]="false">

  <form #dialogForm="ngForm">
    <div class="p-grid">
      <div class="p-col-12 p-md-6 p-lg-6">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label> Task Name</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            {{selectedProjectTask?.name}}
        </div></div>
      </div>
      <div class="p-col-12 p-md-6 p-lg-6">
        <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label> Year</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          {{selectedProjectTaskBalance?.currentYear}}
        </div>
        </div>
      </div>

      <div class="p-col-12 p-md-6 p-lg-6">
        <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label> Accounting Period*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          {{orgAccountingCalendarBeforeGoLive?.title}} - {{orgAccountingCalendarBeforeGoLive?.start | date: Format.Date}} - {{orgAccountingCalendarBeforeGoLive?.end | date: Format.Date}}
        </div>
        </div>
      </div>

    </div>

    <div>
      <strong> Labor: </strong>
    </div>

    <app-data-table [columns]="tableColumns" [value]="taskBalanceTable" [bodyTemplate]="laborBodyTemplate">

      <ng-template #laborBodyTemplate>
        <tr>
          <td>Employee Labor</td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="priorYearEmployeeLaborITD" type="number" [(ngModel)]="selectedProjectTaskBalance.priorYearEmployeeLaborITD"/>
            </span>
          </td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="currentYearEmployeeLaborYTD" type="number" [(ngModel)]="selectedProjectTaskBalance.currentYearEmployeeLaborYTD"/>
            </span>
          </td>
          <td>
            {{ selectedProjectTaskBalance.priorYearEmployeeLaborITD + selectedProjectTaskBalance.currentYearEmployeeLaborYTD | currency: Format.Currency }}
          </td>
        </tr>
        <tr>
          <td>Subcontractor Labor</td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="priorYearSubcontractorLaborITD" type="number" [(ngModel)]="selectedProjectTaskBalance.priorYearSubcontractorLaborITD"/>
            </span>
          </td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="currentYearSubcontractorLaborYTD" type="number" [(ngModel)]="selectedProjectTaskBalance.currentYearSubcontractorLaborYTD"/>
            </span>
          </td>
          <td>
            {{ selectedProjectTaskBalance.priorYearSubcontractorLaborITD + selectedProjectTaskBalance.currentYearSubcontractorLaborYTD | currency: Format.Currency }}
          </td>
        </tr>
        <tr>
          <td>Fringe Labor</td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="priorYearLaborFringeITD" type="number" [(ngModel)]="selectedProjectTaskBalance.priorYearLaborFringeITD"/>
            </span>
          </td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="currentYearLaborFringeYTD" type="number" [(ngModel)]="selectedProjectTaskBalance.currentYearLaborFringeYTD"/>
            </span>
          </td>
          <td>
            {{ selectedProjectTaskBalance.priorYearLaborFringeITD + selectedProjectTaskBalance.currentYearLaborFringeYTD | currency: Format.Currency }}
          </td>
        </tr>

        <tr>
          <td>Overhead Labor</td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="priorYearLaborOverheadITD" type="number" [(ngModel)]="selectedProjectTaskBalance.priorYearLaborOverheadITD"/>
            </span>
          </td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="currentYearLaborOverheadYTD" type="number" [(ngModel)]="selectedProjectTaskBalance.currentYearLaborOverheadYTD"/>
            </span>
          </td>
          <td>
            {{ selectedProjectTaskBalance.priorYearLaborOverheadITD + selectedProjectTaskBalance.currentYearLaborOverheadYTD | currency: Format.Currency }}
          </td>
        </tr>

        <tr>
          <td>G&A Labor</td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="priorYearLaborGnAITD" type="number" [(ngModel)]="selectedProjectTaskBalance.priorYearLaborGnAITD"/>
            </span>
          </td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="currentYearLaborGnAYTD" type="number" [(ngModel)]="selectedProjectTaskBalance.currentYearLaborGnAYTD"/>
            </span>
          </td>
          <td>
            {{ selectedProjectTaskBalance.priorYearLaborGnAITD + selectedProjectTaskBalance.currentYearLaborGnAYTD | currency: Format.Currency }}
          </td>
        </tr>

        <tr>
          <td>M&H Labor</td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="priorYearLaborMnHITD" type="number" [(ngModel)]="selectedProjectTaskBalance.priorYearLaborMnHITD"/>
            </span>
          </td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="currentYearLaborMnHYTD" type="number" [(ngModel)]="selectedProjectTaskBalance.currentYearLaborMnHYTD"/>
            </span>
          </td>
          <td>
            {{ selectedProjectTaskBalance.priorYearLaborMnHITD + selectedProjectTaskBalance.currentYearLaborMnHYTD | currency: Format.Currency }}
          </td>
        </tr>
      </ng-template>
    </app-data-table>
    <div>
      <strong> Material: </strong>
    </div>

    <app-data-table [columns]="tableColumns" [value]="taskBalanceTable" [bodyTemplate]="materialBodyTemplate">

      <ng-template #materialBodyTemplate>
        <tr>
          <td>Material</td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="priorYearMaterialITD" type="number" [(ngModel)]="selectedProjectTaskBalance.priorYearMaterialITD"/>
            </span>
          </td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="currentYearMaterialYTD" type="number" [(ngModel)]="selectedProjectTaskBalance.currentYearMaterialYTD"/>
            </span>
          </td>
          <td>
            {{ selectedProjectTaskBalance.priorYearMaterialITD + selectedProjectTaskBalance.currentYearMaterialYTD | currency: Format.Currency }}
          </td>
        </tr>

        <tr>
          <td>G&A Material</td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="priorYearMaterialGnAITD" type="number" [(ngModel)]="selectedProjectTaskBalance.priorYearMaterialGnAITD"/>
            </span>
          </td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="currentYearMaterialGnAYTD" type="number" [(ngModel)]="selectedProjectTaskBalance.currentYearMaterialGnAYTD"/>
            </span>
          </td>
          <td>
            {{ selectedProjectTaskBalance.priorYearMaterialGnAITD + selectedProjectTaskBalance.currentYearMaterialGnAYTD | currency: Format.Currency }}
          </td>
        </tr>

        <tr>
          <td>M&H Material</td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="priorYearMaterialMnHITD" type="number" [(ngModel)]="selectedProjectTaskBalance.priorYearMaterialMnHITD"/>
            </span>
          </td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="currentYearMaterialMnHYTD" type="number" [(ngModel)]="selectedProjectTaskBalance.currentYearMaterialMnHYTD"/>
            </span>
          </td>
          <td>
            {{ selectedProjectTaskBalance.priorYearMaterialMnHITD + selectedProjectTaskBalance.currentYearMaterialMnHYTD | currency: Format.Currency }}
          </td>
        </tr>
      </ng-template>

    </app-data-table>


    <div>
      <strong> ODC/Travel/Training: </strong>
    </div>

    <app-data-table [columns]="tableColumns" [value]="taskBalanceTable" [bodyTemplate]="odcBodyTemplate">

      <ng-template #odcBodyTemplate>
        <tr>
          <td>ODC</td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="priorYearOdcITD" type="number" [(ngModel)]="selectedProjectTaskBalance.priorYearOdcITD"/>
            </span>
          </td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="currentYearOdcYTD" type="number" [(ngModel)]="selectedProjectTaskBalance.currentYearOdcYTD"/>
            </span>
          </td>
          <td>
            {{ selectedProjectTaskBalance.priorYearOdcITD + selectedProjectTaskBalance.currentYearOdcYTD | currency: Format.Currency }}
          </td>
        </tr>

        <tr>
          <td>Travel</td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="priorYearTravelITD" type="number" [(ngModel)]="selectedProjectTaskBalance.priorYearTravelITD"/>
            </span>
          </td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="currentYearTravelYTD" type="number" [(ngModel)]="selectedProjectTaskBalance.currentYearTravelYTD"/>
            </span>
          </td>
          <td>
            {{ selectedProjectTaskBalance.priorYearTravelITD + selectedProjectTaskBalance.currentYearTravelYTD | currency: Format.Currency }}
          </td>
        </tr>

        <tr>
          <td>Training</td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="priorYearTrainingITD" type="number" [(ngModel)]="selectedProjectTaskBalance.priorYearTrainingITD"/>
            </span>
          </td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="currentYearTrainingYTD" type="number" [(ngModel)]="selectedProjectTaskBalance.currentYearTrainingYTD"/>
            </span>
          </td>
          <td>
            {{ selectedProjectTaskBalance.priorYearTrainingITD + selectedProjectTaskBalance.currentYearTrainingYTD | currency: Format.Currency }}
          </td>
        </tr>

        <tr>
          <td>G&A ODC</td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="priorYearOdcGnAITD" type="number" [(ngModel)]="selectedProjectTaskBalance.priorYearOdcGnAITD"/>
            </span>
          </td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="currentYearOdcGnAYTD" type="number" [(ngModel)]="selectedProjectTaskBalance.currentYearOdcGnAYTD"/>
            </span>
          </td>
          <td>
            {{ selectedProjectTaskBalance.priorYearOdcGnAITD + selectedProjectTaskBalance.currentYearOdcGnAYTD | currency: Format.Currency }}
          </td>
        </tr>

        <tr>
          <td>M&H ODC</td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="priorYearOdcMnHITD" type="number" [(ngModel)]="selectedProjectTaskBalance.priorYearOdcMnHITD"/>
            </span>
          </td>
          <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input pInputText name="currentYearOdcMnHYTD" type="number" [(ngModel)]="selectedProjectTaskBalance.currentYearOdcMnHYTD"/>
            </span>
          </td>
          <td>
            {{ selectedProjectTaskBalance.priorYearOdcMnHITD + selectedProjectTaskBalance.currentYearOdcMnHYTD | currency: Format.Currency }}
          </td>
        </tr>
      </ng-template>
    </app-data-table>
  </form>

  <p-footer>
    <div class="details">
      <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel"
              (click)="cancelProjectTaskBalance()">
      </button>
      <span *ngIf="!goLiveAccountingPeriodClosed || inSolutionManager">
        <span *ngIf="saveOrUpdateProjectTaskBalanceButton">
          <button pButton type="button" class="button-action" icon="fa fa-check" label="Save"
                  (click)="saveProjectTaskBalance()"
                  [disabled]="!dialogForm.form.valid">
          </button>
        </span>
        <span *ngIf="!saveOrUpdateProjectTaskBalanceButton">
          <button pButton type="button" class="button-action" icon="fa fa-check" label="Update"
                  (click)="updateProjectTaskBalance()">
          </button>
        </span>
      </span>

    </div>
  </p-footer>

</p-dialog>
